import ctl from '@netlify/classnames-template-literals'
import { ReactNode } from 'react'

export function HighlightOverlay({ children }: { children?: ReactNode }) {
	return (
		<div className="absolute inset-[-4px] pointer-events-none" data-render-exclude>
			<div
				className={ctl(
					`absolute inset-0 border-2 border-red-500`,
				)}
			/>
			<div
				className={ctl(
					`absolute inset-0 border-1 border-white`,
				)}
			/>
			{children}
		</div>
	)
}
